/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactShareRequest {
    getFixupPrototypeFunction() { return ArtifactShareRequest.fixupPrototype; }

    static newInstance(model: Partial<ArtifactShareRequest>): ArtifactShareRequest {
        let obj = Object.assign(new ArtifactShareRequest(), model);
        ArtifactShareRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactShareRequest>): ArtifactShareRequest {
        if (!model) return null;
        return ArtifactShareRequest.newInstance(<ArtifactShareRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactShareRequest) {
        if (!obj) return;

        models.ArtifactShareRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactShareRequest): boolean {
        Object.setPrototypeOf(obj, ArtifactShareRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * How to share the artifact
     */
    share_type: models.ArtifactShareType;

    /**
     * ID of the in-tenant user to share with; required when share_type is 'user'
     */
    target_user_id: string;

    /**
     * External email address to share with; required when share_type is 'email'
     */
    target_email: string;

}
